export interface OfferingQueryParams {
  sort?: OfferingQuerySort;

  /**
   * shows properties that are in PRE_LAUNCH state, must be admin
   * TODO replace with general offering status query
   */
  showPreLaunch?: boolean;

  /**
   * page | [1, max page]
   * size | > 0
   */
  page?: number;
  size?: number;
}

export const OFFERINGS_SORT_ID_ASC = 'id:asc';
export const OFFERINGS_SORT_ID_DESC = 'id:desc';
export const OFFERINGS_SORT_PROPERTY_RANK_ASC = 'propertyRank:asc';
export const OFFERINGS_SORT_PROPERTY_RANK_DESC = 'propertyRank:desc';
export type OfferingQuerySort =
  | typeof OFFERINGS_SORT_ID_ASC
  | typeof OFFERINGS_SORT_ID_DESC
  | typeof OFFERINGS_SORT_PROPERTY_RANK_ASC
  | typeof OFFERINGS_SORT_PROPERTY_RANK_DESC;
